import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Login from '../../components/auth/Login';
import MinimalHeader from '../../components/layout/MinimalHeader';
import '../../styles/Auth.css';

const LoginPage = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (email, password) => {
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError('Invalid email or password.');
    }
    setLoading(false);
  };

  return (
    <>
      <MinimalHeader />
      <div className="auth-container">
        <h2 className="auth-title">Login to Your Account</h2>
        <Login onSubmit={handleLogin} loading={loading} error={error} />
        <p className="auth-footer">
          Don't have an account? <Link to="/auth/signup">Sign up</Link>
        </p>
      </div>
    </>
  );
};

export default LoginPage;
